// create flux standard actions (FSA)

import {createAction} from 'uix/actions'

export const setContextHelpOn = createAction('SET_CONTEXT_HELP_ON', value => value)
export const navigateHelp = createAction('NAVIGATE_HELP', (wikiIdent, navIdent) => ({
  wikiIdent,
  navIdent,
}))
